<template>

	<div class="live-view-header container-fluid" :style="headerStyle">
		<div class="row">
			<div class="col col-auto">
				<span class="icon glyphicon glyphicon-home">
					<a href="/#/dashboard"><img src="../../assets/img/home.svg"></img></a>
				</span>
				<span class="name">{{ name }}</span>
				<span v-if="name">&ndash;</span>
				<span v-if="name" class="state-name">{{ processstate.name }}</span>
				<span class="id">{{ id }}</span>
			</div>
			<div class="col text-right">
				<erco-dropdown v-if="processstate.items.length"
				               size="sm"
				               :label="dropdownLabel"
				               :right="true"
				               :items="processstate.items"
				               :useLabelInline="true"
				               @change="handleStateChange">
				</erco-dropdown>
			</div>
		</div>
	</div>

</template>

<script>

	import ErcoDropdown from '@/components/molecules/ErcoDropdown';

	export default {
		name: 'ErcoLiveSelectionHeaderMolecule',

		props: {
			name: {
				type: String,
				default: '',
			},
			id: {
				type: String,
				default: '',
			},
			processstate: {
				type: Object,
				default: () => ({
					id: '',
					name: '',
					items: [],
					currentProcessStatusItem: null,
				}),
			},
		},

		data() {
			return {

			};
		},

		computed: {
			headerStyle() {
				const bgColor = (this.processstate.id === '') ?
				                'rgba(2, 117, 216, 1)' :
				                'rgba(68, 157, 68, 1)';

				return {
					'background-color': bgColor,
				};
			},

			dropdownLabel() {
				if (this.processstate.currentProcessStatusItem === null) {
					return 'Aktion';
				}

				return this.processstate.currentProcessStatusItem.S_Status;
			},
		},

		methods: {
			handleStateChange(item) {
				this.$emit('change', item.currentValue);
			},
		},

		components: {
			ErcoDropdown,
		},
	};
</script>


<style lang="scss">
	.live-view-header {
		background-color: black;
		color: white;
		padding-top: 1rem;
		padding-bottom: 1rem;

		.icon {
			position: absolute;
			cursor: pointer;

			& > a > img {
				vertical-align: baseline;
			}
		}

		.name {
			margin-left: 3rem;
		}

		.id {
			color: rgba(255, 255, 255, 0.5);
			margin-left: 2rem;
		}
	}
</style>



// WEBPACK FOOTER //
// ErcoLiveViewHeader.vue?7b37729a